import { Controller } from "@hotwired/stimulus"

// Mostra/oculta elementos condicionalmente com base no valor de um campo.
//
// Uso com boolean:
//   data-controller="toggler" data-toggler-boolean-value="true"
//   campo: data-toggler-target="field"
//   alvo:  data-toggler-target="toggle"
//
// Uso com valor específico:
//   data-controller="toggler" data-toggler-show-value="Boleto"
//   campo: data-toggler-target="field" + ouvir evento de mudança
//   alvo:  data-toggler-target="toggle"

export default class extends Controller {
  static targets = ["field", "toggle"]
  static values  = { boolean: { type: Boolean, default: null }, show: String }

  connect() {
    this.update()
  }

  toggle(event) {
    if (event?.detail?.value !== undefined) {
      this._currentValue = event.detail.value
    }
    this.update()
  }

  update() {
    const show = this.#shouldShow()
    this.toggleTargets.forEach(el => {
      el.style.display = show ? "" : "none"
    })
  }

  #shouldShow() {
    if (!this.hasFieldTarget) return true

    const field = this.fieldTarget

    if (this.hasBooleanValue && this.booleanValue !== null) {
      return field.checked === this.booleanValue
    }

    if (this.hasShowValue) {
      const value = this._currentValue ?? field.querySelector("[data-ui--combobox-target='hidden']")?.value ?? field.value
      return value === this.showValue
    }

    return field.checked
  }
}
